import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import { Card, CardContent, CardHeader, CardTitle } from '@/common/ui/card'
import { GetLineAnalyticsResponse } from '@/modules/dashboard/type'
import { format } from 'date-fns'
import { th } from 'date-fns/locale'
import { Spinner } from '@/common/ui/spinner'
import { DatePicker } from '@/common/components/DatePicker'

interface LineAnalyticsListingProps {
	data?: GetLineAnalyticsResponse
	isLoading?: boolean
}

export default function LineAnalyticsListing({
	data,
	isLoading,
}: LineAnalyticsListingProps) {
	if (isLoading) {
		return (
			<div className="flex h-64 items-center justify-center">
				<Spinner />
			</div>
		)
	}

	if (!data) {
		return null
	}

	return (
		<div className="space-y-4">
			<div className="flex items-start justify-between">
				<Heading
					title="โควต้าการใช้งาน LINE"
					description="ข้อมูลโควต้า การใช้งาน และสถิติข้อความ LINE"
				/>
			</div>
			<Separator />

			{/* Quota Card - Merged */}
			<Card>
				<CardHeader>
					<CardTitle>โควต้า</CardTitle>
				</CardHeader>
				<CardContent>
					{data.quota?.success && data.consumption?.success ? (
						<div className="space-y-2">
							<div className="text-2xl">
								{data.consumption.totalUsage?.toLocaleString() || 0} /{' '}
								{data.quota.value?.toLocaleString() || 0}
							</div>
						</div>
					) : (
						<div className="text-sm text-muted-foreground">
							ไม่สามารถดึงข้อมูลโควต้าได้
						</div>
					)}
				</CardContent>
			</Card>

			{/* Date Picker */}
			<div className="flex items-baseline justify-between">
				{data.date ? (
					<div className="text-sm text-muted-foreground">
						วันที่:{' '}
						{format(new Date(data.date), 'dd MMMM yyyy', { locale: th })}
					</div>
				) : (
					<div />
				)}
				<DatePicker placeholder="เลือกวันที่" />
			</div>

			{/* Message Statistics - Split into separate cards */}
			<div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
				{/* Push Card */}
				<Card>
					<CardHeader>
						<CardTitle className="text-base">ส่งรายคน</CardTitle>
					</CardHeader>
					<CardContent>
						<div className="text-2xl font-bold">
							{data.messageStatistics?.push?.toLocaleString() || 0}
						</div>
					</CardContent>
				</Card>

				{/* Multicast Card */}
				<Card>
					<CardHeader>
						<CardTitle className="text-base">ส่งหลายคน</CardTitle>
					</CardHeader>
					<CardContent>
						<div className="text-2xl font-bold">
							{data.messageStatistics?.multicast?.toLocaleString() || 0}
						</div>
					</CardContent>
				</Card>

				{/* Broadcast Card */}
				<Card>
					<CardHeader>
						<CardTitle className="text-base">ส่ง broadcast</CardTitle>
					</CardHeader>
					<CardContent>
						<div className="text-2xl font-bold">
							{data.messageStatistics?.broadcast?.toLocaleString() || 0}
						</div>
					</CardContent>
				</Card>

				{/* Reply Card */}
				<Card>
					<CardHeader>
						<CardTitle className="text-base">ข้อความตอบกลับ</CardTitle>
					</CardHeader>
					<CardContent>
						<div className="text-2xl font-bold">
							{data.messageStatistics?.reply?.toLocaleString() || 0}
						</div>
					</CardContent>
				</Card>
			</div>
		</div>
	)
}
